class CustomerStatements {

    constructor(paramContainer, paramIntervall) {

        this.slideContainer = paramContainer;

        this.slideIntervall = paramIntervall;

        this.slideItems = this.slideContainer.querySelector(".customer-statements__items");
        this.slideItem = this.slideContainer.querySelectorAll(".customer-statements__item");

        this.isAutoplay = this.slideContainer.dataset.autoplay;
        this.navBullet = this.slideContainer.querySelectorAll(".customer-statements__bullet");

        if (this.slideContainer.querySelectorAll(".customer-statements__bullet").length > 0) {

            this.navBullet
                .forEach((dot, index) => {
                    dot.addEventListener("click", () => {
                        var slideIndex = dot.dataset.slideto;
                        this.slideTo(slideIndex);
                    });

                });

            if (this.isAutoplay == 1) {
                this.autoplaySlide();
            }

        }

    }

    slideTo(paramSlideIndex) {
        var slideToEl = this.slideItem.item(paramSlideIndex);

        if (!slideToEl) return;

        const width = slideToEl.offsetWidth;
        this.slideItems.scrollLeft = paramSlideIndex * width;

        this.nextActiveItem(slideToEl, this.slideContainer);
    }

    nextActiveItem(index, paramContainer) {
        const slideIndex = index.dataset.slideindex;
        paramContainer.querySelector('.customer-statements__bullet.active').classList.remove('active');
        paramContainer.querySelectorAll('.customer-statements__bullet')[slideIndex].classList.add('active');
    }

    autoplaySlide() {

        this.countItem = this.navBullet.length;
        const autoplay = setInterval(() => navigate(), this.slideIntervall);

        this.navBullet.forEach((bullet) => {
            bullet.addEventListener("mouseenter", () => {
                clearInterval(autoplay);
            });
        });

        this.slideItems.addEventListener("mouseenter", () => {
            clearInterval(autoplay);
        });

        const navigate = () => {
            var activeItem = this.slideContainer.querySelector('.customer-statements__bullet.active');
            var slideIndex = Number(activeItem.dataset.slideto);
            var nextSlideIndex = slideIndex + 1;
            if (nextSlideIndex >= this.countItem) {
                var nextSlideIndex = 0;
            }

            this.slideTo(nextSlideIndex);
        }

    }
}

if (document.querySelector('.customer-statements__carousel')) {

    const allSlideContainer = document.querySelectorAll(".customer-statements__carousel");

    allSlideContainer.forEach(slideContainer => {
        const slideIntervall = 8000;
        let slideObj = new CustomerStatements(slideContainer, slideIntervall);
    });
}

